// src/entities/sales/sales.api.js
import { api } from '../../api/rtk';
import { 
  createSale, 
  updateSale, 
  getSale, 
  getSales, 
  deleteSale,
  markSaleAsSold,
  revertSaleToListed,
  addCardToSale,
  removeCardFromSale,
  updateSaleCard,
  addSupplyToSale
} from '../../utils/firebase/sales';

export const salesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSales: build.query({
      async queryFn({ uid, filters = {} }) {
        const data = await getSales(uid, filters);
        return { data };
      },
      providesTags: ['Sale']
    }),
    getSale: build.query({
      async queryFn({ uid, saleId }) {
        const data = await getSale(uid, saleId);
        return { data };
      },
      providesTags: (_r, _e, { saleId }) => [
        { type: 'Sale', id: saleId },
        { type: 'SaleCard', id: saleId }
      ]
    }),
    createSale: build.mutation({
      async queryFn({ uid, saleData }) {
        const result = await createSale(uid, saleData);
        return { data: result };
      },
      invalidatesTags: ['Sale']
    }),
    updateSale: build.mutation({
      async queryFn({ uid, saleId, updateData }) {
        const result = await updateSale(uid, saleId, updateData);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'Sale', id: saleId },
        'Sale'
      ]
    }),
    deleteSale: build.mutation({
      async queryFn({ uid, saleId }) {
        await deleteSale(uid, saleId);
        return { data: { saleId } };
      },
      invalidatesTags: ['Sale']
    }),
    markSaleAsSold: build.mutation({
      async queryFn({ uid, saleId, saleFields }) {
        const result = await markSaleAsSold(uid, saleId, saleFields);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'Sale', id: saleId },
        { type: 'SaleCard', id: saleId },
        'Sale'
      ]
    }),
    revertSaleToListed: build.mutation({
      async queryFn({ uid, saleId }) {
        const result = await revertSaleToListed(uid, saleId);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'Sale', id: saleId },
        { type: 'SaleCard', id: saleId },
        'Sale'
      ]
    }),
    addCardToSale: build.mutation({
      async queryFn({ uid, saleId, cardData }) {
        const result = await addCardToSale(uid, saleId, cardData);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'SaleCard', id: saleId },
        { type: 'Sale', id: saleId }
      ]
    }),
    removeCardFromSale: build.mutation({
      async queryFn({ uid, saleId, cardId }) {
        await removeCardFromSale(uid, saleId, cardId);
        return { data: { saleId, cardId } };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'SaleCard', id: saleId },
        { type: 'Sale', id: saleId }
      ]
    }),
    updateSaleCard: build.mutation({
      async queryFn({ uid, saleId, cardId, updateData }) {
        const result = await updateSaleCard(uid, saleId, cardId, updateData);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'SaleCard', id: saleId },
        { type: 'Sale', id: saleId }
      ]
    }),
    addSupplyToSale: build.mutation({
      async queryFn({ uid, saleId, supplyData }) {
        const result = await addSupplyToSale(uid, saleId, supplyData);
        return { data: result };
      },
      invalidatesTags: (_r, _e, { saleId }) => [
        { type: 'Sale', id: saleId }
      ]
    })
  })
});

export const {
  useGetSalesQuery,
  useGetSaleQuery,
  useCreateSaleMutation,
  useUpdateSaleMutation,
  useDeleteSaleMutation,
  useMarkSaleAsSoldMutation,
  useRevertSaleToListedMutation,
  useAddCardToSaleMutation,
  useRemoveCardFromSaleMutation,
  useUpdateSaleCardMutation,
  useAddSupplyToSaleMutation
} = salesApi;

